/*
 * @Author: JamesWong
 * @Description: 激活码模块繁体包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:36:56
 */
export default {
  activated: '已啟動',
  unactivated: '未啟動',
  order: '序號',
  activeCode: '啟動碼',
  machineNumber: '機器編碼',
  machineCode: '設備機器碼',
  activeTime: '啟動時間',
  operation: '操作',
  delete: '刪除',
  dataNotAvailable: '暫無數據',
  cancelActived: '取消啟動',
  cancel: '取消',
  comfirm: '確定',
  subactiveCodeCanceled: '取消激活',
  subactiveCodeCanceledTips: '確定取消該設備的啟動碼？',
  subactiveCodeDeleted: '刪除子啟動碼',
  subactiveCodeDeletedTips: '確定刪除該條啟動碼嗎？',
  close: '關閉',
  '点击详情': '點擊詳情',
  '未启用': '未啟用',
  '可联系商务开通': '可聯系商務開通',
  '下载链接': '下載鏈接'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/activeCode.js